<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-轮播图
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
  

      <!-- 类型 -->
      <el-form-item label="类型：">
        <el-radio-group v-model="curItem.params.type" @change="editSet">
          <el-radio :label="item.id" v-for="(item,index) in curItem.params.type_arr" :key="index">{{ item.text }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标题名称" v-if="curItem.params.type != '3'">
        <el-input v-model="curItem.params.name" ></el-input>
      </el-form-item>


  


      <el-form-item label="限制数量" v-if="curItem.params.type != '3'">
        <el-input v-model="curItem.params.limit" ></el-input>
      </el-form-item>
 
 
 
    </el-form>

    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink
    >
  </div>
</template>

<script>
import Setlink from "@/components/setlink/Setlink";
import AdvApi from "@/api/adv.js";
export default {
  components: {
    Setlink,
  },
  data() {
    return {
      advList: [],
      /*是否选择链接*/
      is_linkset: false,
      index: null,
    };
  },
  props: ["curItem", "selectedIndex"],
  created() {
    // this.getAdvList();
  },
  methods: {
    formatTooltip(val) {
      return (val*2) + ' px';
    },
    formatTooltipa(val) {
      return (val);
    },
    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.curItem.linkUrl = e.url;
        this.curItem.linkName = "链接到" + " " + e.type + " " + e.name;
      }
    },
  },
};
</script>

<style>
.video {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video video {
  width: 200px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Hotproject.vue